import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../login/auth.service';
import {
  GetPropertyValues,
  Product,
  ProductSearchDto,
  Property,
  SearchPropertyDto
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  search(payload: SearchPropertyDto) {
    return this.http.post<Property[]>(`${environment.BACKEND}/property/private_search`, payload);
  }

  searchByProductDto(payload: ProductSearchDto) {
    return this.http.post<{ property: Property; values: string[] }[]>(
      `${environment.BACKEND}/property/search_by_product_dto`,
      payload
    );
  }

  getList(): Observable<Property[]> {
    return this.http.get<Property[]>(`${environment.BACKEND}/property/list`);
  }

  createProperty(description: string) {
    return this.http.post<Property>(`${environment.BACKEND}/property/create`, { description });
  }

  getValuesByPropertyId(payload: GetPropertyValues): Observable<{ value: string }[]> {
    return this.http.post<{ value: string }[]>(
      `${environment.BACKEND}/property/values/private_list`,
      payload
    );
  }

  addNewPropertyToProduct(product_id: number, property_id: number, value: string) {
    const resp = this.http.post<
      {
        id: number;
        value: string;
        property: { id: number; description: string };
        product: Product;
      }[]
    >(`${environment.BACKEND}/property/add_to_product`, { product_id, property_id, value });
    return resp;
  }

  updatePropertyOfProduct(rowId: number, value: string) {
    return this.http.put<
      {
        id: number;
        value: string;
        property: { id: number; description: string };
        product: Product;
      }[]
    >(`${environment.BACKEND}/property/update_property_of_product`, { rowId, value });
  }

  deletePropertyFromProduct(rowId: number) {
    return this.http.delete<
      {
        id: number;
        value: string;
        property: { id: number; description: string };
        product: Product;
      }[]
    >(`${environment.BACKEND}/property/product/${rowId}`);
  }
}
